var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47874 11.0798C10.5342 11.0798 12.2004 9.41355 12.2004 7.35813C12.2004 5.30272 10.5342 3.63647 8.47874 3.63647C6.42332 3.63647 4.75708 5.30272 4.75708 7.35813C4.75708 9.41355 6.42332 11.0798 8.47874 11.0798Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8534 8.92277C17.7848 8.21978 18.7807 6.08413 18.0777 4.15268C17.3747 2.22122 15.2391 1.22535 13.3076 1.92834",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0354 20.3846V16.663C1.0354 15.6352 1.86852 14.8021 2.89623 14.8021H14.0612C15.0889 14.8021 15.922 15.6352 15.922 16.663V20.3846",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5679 12.1011H17.9635C18.9912 12.1011 19.8243 12.9342 19.8243 13.9619V16.9172V18.3949",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_2065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.204834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidate);
export default __webpack_public_path__ + "static/media/candidate.7abd89ee449fd39ba50c96f894f388cf.svg";
export { ForwardRef as ReactComponent };